import * as e from "react";
import { forwardRef as o } from "react";
const s = o(function(t, r) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7 5H17C18.1046 5 19 5.89543 19 7V19H5V7C5 5.89543 5.89543 5 7 5Z",
        stroke: "currentColor",
        strokeWidth: 2
      }
    ),
    /* @__PURE__ */ e.createElement(
      "line",
      {
        stroke: "currentColor",
        strokeWidth: 2,
        x1: 8,
        x2: 16,
        y1: 9,
        y2: 9
      }
    ),
    /* @__PURE__ */ e.createElement(
      "line",
      {
        stroke: "currentColor",
        strokeWidth: 2,
        x1: 8,
        x2: 16,
        y1: 12,
        y2: 12
      }
    ),
    /* @__PURE__ */ e.createElement(
      "line",
      {
        stroke: "currentColor",
        strokeWidth: 2,
        x1: 8,
        x2: 16,
        y1: 15,
        y2: 15
      }
    )
  );
});
export {
  s as Betslip
};
